export const adaptProducts = (preorderData) => {
	if (!preorderData) return [];

	const products = preorderData?.purchase_detail?.products || [];

	return products.map((product, index) => ({
		key: `product-${index}`,
		image: product.image || null,
		name: product.name || '-',
		quantity: product.quantity || 1,
		unit_price: product?.quotation_price ? product?.quotation_price?.base_unit_price : product.unit_price || product.price || 0,
		discount: product.valid_data_payment?.discount || 0,
		final_price: product.total,
		recipe: null,
	}));
};
